import apiClient from '@/lib/axios';

/**
 * Downloads the lead sheet PDF for a given lead ID.
 * Opens the PDF in a new browser tab for printing/viewing.
 *
 * @param leadId - The ID of the lead
 * @param jobNumber - Optional job number for the filename
 * @throws Error if the PDF generation fails
 */
export const downloadLeadSheet = async (
  leadId: number,
  jobNumber?: string
): Promise<void> => {
  const response = await apiClient.get(`/leads/${leadId}/lead-sheet`, {
    responseType: 'blob',
  });

  // Create a blob URL from the response
  const blob = new Blob([response.data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);

  // Open in new tab for printing
  const newWindow = window.open(url, '_blank');

  // If popup was blocked, fall back to download
  if (!newWindow) {
    const link = document.createElement('a');
    link.href = url;
    link.download = jobNumber
      ? `LeadSheet-${jobNumber}.pdf`
      : `LeadSheet-${leadId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // Cleanup the blob URL after a short delay to allow the window to load
  setTimeout(() => {
    window.URL.revokeObjectURL(url);
  }, 1000);
};
